import Vue from "vue";
import "normalize.css";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./filters";
import ajax from "./utils/ajax";
import Vant from "vant";
// import "@vant/touch-emulator";
import "vant/lib/index.css";
import TheDetail from "./components/TheDetail.vue";
import TheLayout from "./components/TheLayout/Index.vue";
import VideoPlayer from "vue-video-player/src";
import "vue-video-player/src/custom-theme.css";
import "video.js/dist/video-js.css";
Vue.use(VideoPlayer);

import fundebug from "fundebug-javascript";
import fundebugVue from "fundebug-vue";
import "fundebug-revideo";
import baiduAnalytics from "vue-baidu-analytics";

if (process.env.NODE_ENV === "production") {
  // 百度统计
  Vue.use(baiduAnalytics, {
    router: router,
    siteIdList: ["3a38e0c705f1b7383f07b41d2f015584"],
    isDebug: false,
  });

  // 代码监控
  fundebug.init({
    apikey: "3c55c4326b60fbd8461bb9da05cba2a3548a863476fc6589f24bd93c4d7a59ba",
    appversion: "1.0.0",
    releasestage: "production",
    setHttpBody: true,
  });
  new fundebugVue(fundebug).installVueErrorHandler(Vue);
}

Vue.prototype.$axios = ajax;
Vue.use(Vant);
Vue.component("TheDetail", TheDetail);
Vue.component("TheLayout", TheLayout);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
